import { useQuery } from 'react-query';
import { FetchCipApplicationResponse, fetchCipApplication } from 'apis/banking';

export type ICipApplication = FetchCipApplicationResponse;

const getCipApplication = async () => {
  const data = await fetchCipApplication();
  return data;
};

const useQueryCipApplication = ({ enabled }: { enabled: boolean }) => {
  const {
    data,
    isLoading: is_loading,
    refetch,
  } = useQuery(['getCipApplication'], () => getCipApplication(), {
    enabled,
  });
  return {
    data,
    is_loading,
    refetch,
  };
};

export default useQueryCipApplication;
